// extracted by mini-css-extract-plugin
export default {"wrap":"gq-z","logoContainer":"hq-z","brandImg":"iq-z","logoImg":"jq-z","logoButton":"kq-z"};